import React, { Fragment } from 'react'
import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import { Dialog } from 'primereact/dialog';
import { useFormik } from "formik";
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { userService, roleService } from "../../services/extensions";
import properties from '../../config/environmentProperties';
import { useEffect } from 'react';
import { settingService } from '../../services/extensions';
export default function UserReport() {
  const [filterDialog, setFilterDialog] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [newForm, setNewForm] = useState(false);
  const [showButton, setShowButton] = useState(false);
  const [filterObj, setFilterObj] = useState('');
  const [users, setUsers] = useState([]);
  const [projects, setProjects] = useState([]);
  const [selectedCity1, setSelectedCity1] = useState(null);

  let count = 0;
  useEffect(() => {
    if (count == 0) {
      getProjects();
    }
    count++;
  }, []);

  const getProjects = () => {
    settingService.getProjectReport().then((resp) => {
      setProjects(resp.data.data);
    });
  };

  const searchUser = (data) => {
    setShowButton(true);
    var dataObj = {};
    if (data.bu !== "") {
      dataObj.businessUnitId = data.bu;
    }
    if (data.rm !== "") {
      dataObj.rmName = data.rm; 
    }
    if (data.projectId!== "") {
      dataObj.projectId = data.projectId;
    }
    if (data.projectName !== "") {
      dataObj.title= data.projectName;
    }
    let isClear = true;
    for (let v of Object.keys(data)) {
      if (data[v] != undefined && data[v] != '') {
        isClear = false
      }
    }
    if (isClear) { setShowMessage(false) }
    try {
      setFilterObj(dataObj);
      settingService.getProjectReport(dataObj).then(
        (resp) => {
          if (resp.status === 200) {
            setProjects(resp.data.data);
            setShowButton(false);
            searchForm.resetForm();
            setFilterDialog(false);
          }
        },
        (error) => {
          setUsers();
          setShowButton(true);
        }
      );
    } catch (error) { }
  };
  const searchForm = useFormik({
    initialValues: {
      projectId: "",
      projectName: "",
      bu: "",
      region: "",
      rm: "",
    },
    validate: (data) => {
      let errors = {};
      return errors;
    },
    onSubmit: (data) => {
      setShowMessage(true);
      searchUser(data);
      searchForm.resetForm();
    },
  });

  const isFormFieldValid = (name) =>
    !!(searchForm.touched[name] && searchForm.errors[name]);
  const SearchForm = () => {
    return (
      <Fragment>
        <Dialog header="Project Filter" visible={filterDialog} position="right" modal style={{ width: '500px' }}
          onHide={() => setFilterDialog(false)}
          draggable={false} resizable={false}>
          <form onSubmit={searchForm.handleSubmit}>
            <div className="grid p-fluid">
              <div className="col-6 field">
                <label htmlFor="projectId" className={classNames({ "p-error": isFormFieldValid("projectId"), })}>Project Id</label>
                <span className="p-float-label">
                  <InputText name="projectId" value={searchForm.values.projectId} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="projectName" className={classNames({ "p-error": isFormFieldValid("projectName"), })}>Project Name</label>
                <span className="p-float-label">
                  <InputText name="projectName" value={searchForm.values.projectName} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label htmlFor="bu" className={classNames({ "p-error": isFormFieldValid("bu"), })}>BU</label>
                <span className="p-float-label">
                  <InputText name="bu" value={searchForm.values.bu} onChange={searchForm.handleChange} />
                </span>
              </div>
              <div className="col-6 field">
                <label className={classNames({ "p-error": isFormFieldValid("rm") })}>Project Manager</label>
                <span className="p-float-label">
                  <InputText name="rm" value={searchForm.values.rm} onChange={searchForm.handleChange} />
                </span>
              </div>
            </div>
            <div className="col-12">
              <Button type="submit" icon="pi pi-search" label="Search" className="p-button-rounded" />
            </div>
          </form>
        </Dialog>
      </Fragment>
    );
  };

  const tableHeader = () => {
    return (
      <Fragment>
        <div className="grid">
          <div
            className="col mt-3 mb-2"
            style={{ paddingLeft: "25px", paddingRight: "21px" }}
          >
            <span className="heading">
              Project's List
              <div className="heading-actions">
                <Button icon="pi pi-replay" className="p-button-rounded p-button-help p-button-text" aria-label="Replay" onClick={() => { setFilterObj('');getProjects(); }} />
                <Button icon="pi pi-filter" className="p-button-rounded p-button-help p-button-text" aria-label="Filter" onClick={() => setFilterDialog(true)} />
              </div>
            </span>
          </div>
        </div>
      </Fragment>
    );
  };

  return (
    <div>
      {SearchForm()}
      <DataTable
        value={projects}
        header={tableHeader}
        emptyMessage="No Project found."
        paginator
        responsiveLayout="scroll"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
        rows={10}
        rowsPerPageOptions={[10, 20, 50]}
        editMode="row"
      >
        <Column header="Client" field="client" headerStyle={{ width: "4rem" }} sortable></Column>
        <Column field="projectId" header="Project ID" headerStyle={{ width: "4rem" }} sortable></Column>
        <Column field="projectName" header="Project Name" headerStyle={{ width: "4rem" }} sortable className="initCap"></Column>
        <Column header="Project Type" field="projectType" headerStyle={{ width: "4rem" }} sortable></Column>
        <Column header="BU" field="bu"  headerStyle={{ width: "4rem" }} sortable></Column>
        <Column header="Region" field="region" headerStyle={{ width: "4rem" }} sortable></Column>
        <Column header="Project Manager" field="pm" headerStyle={{ width: "4rem" }} sortable></Column>
      </DataTable>
    </div>
  )
}